// extracted by mini-css-extract-plugin
module.exports = {"bannerSlot":"OrderListPage_bannerSlot__f0pPn","flush":"OrderListPage_flush__3-kbC"};